import React from 'react';

const Content = () => {
    return (
        <section id='about' className="bg-white py-16 md:py-24 font-sans border-b border-gray-500">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

                    <div className="w-full lg:w-1/2">

                        <h2 className="text-3xl md:text-4xl font-extrabold text-black mb-6">
                            Quality Wipers Made With Care
                        </h2>

                        <p className="text-gray-600 text-base leading-relaxed mb-8 text-justify">
                            We are a small but dedicated wiper manufacturing unit, where only 
                            <span className="font-semibold text-black"> 4 – 5 skilled craftsmen </span> 
                            hand-build each wiper with precision and care. Our goal is simple — to deliver durable,
                            smooth, and reliable wiping performance to every customer.
                            <br /><br />
                            We supply our products to local shops, a few states, and even neighbouring countries.
                            Even though we are a small unit, we never compromise on quality. This commitment is helping
                            our brand slowly build trust and recognition in the market.
                        </p>

                        <div className="flex flex-wrap items-center gap-8 md:gap-12 mb-10">
                            <div>
                                <h3 className="text-4xl font-extrabold text-blue-700">Locale</h3>
                                <p className="text-black font-semibold mt-1">Market Reach</p>
                            </div>
                            <div>
                                <h3 className="text-4xl font-extrabold text-blue-700"> 005</h3>
                                <p className="text-black font-semibold mt-1">Team Member</p>
                            </div>
                            <div>
                                <h3 className="text-4xl font-extrabold text-blue-700">001</h3>
                                <p className="text-black font-semibold mt-1">Manufacturing Units</p>
                            </div>
                        </div>

                        {/* <div className="flex flex-wrap gap-4">
                            <button className="bg-blue-700 text-white px-6 py-3 font-medium text-sm hover:bg-blue-800 transition shadow-sm">
                                About BNM Wipers
                            </button>
                            <button className="bg-blue-700 text-white px-6 py-3 font-medium text-sm hover:bg-blue-800 transition shadow-sm">
                                About BNM Group
                            </button>
                            <button className="bg-blue-700 text-white px-6 py-3 font-medium text-sm hover:bg-blue-800 transition shadow-sm">
                                Quality Warranty
                            </button>
                        </div> */}

                    </div>

                    <div className="w-full lg:w-1/2">
                        <div className="relative">
                            <img
                                src="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?q=80&w=2070&auto=format&fit=crop"
                                alt="BNM Wipers Headquarters"
                                className="w-full h-auto object-cover rounded-[2rem] shadow-xl"
                            />

                            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                <h3 className="text-white text-5xl md:text-6xl font-extrabold tracking-widest drop-shadow-lg opacity-90 uppercase" style={{ fontFamily: 'sans-serif' }}>
                                    BNM WIPERS
                                </h3>
                            </div>
                        </div>
                    </div>

                    {/* <div className="w-full lg:w-1/2">
                        <div className="relative h-full">

                            <video
                                className="w-full h-full object-cover rounded-[2rem] shadow-xl"
                                autoPlay
                                loop
                                muted
                                playsInline 
                            >
                                <source src="https://youtube.com/shorts/bsJrs2alm4k?si=UQ9oO9zXI_pbyUNO" type="video/mp4" />
                                Your browser does not support the video tag.
                            </video>

                            <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                                <h3 className="text-white text-5xl md:text-6xl font-extrabold tracking-widest drop-shadow-lg opacity-90 uppercase" style={{ fontFamily: 'sans-serif' }}>
                                    BNM WIPER
                                </h3>
                            </div>

                        </div>
                    </div> */}

                </div>
            </div>
        </section>
    );
};

export default Content;